<template>
  <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
    <!--begin::Logo-->
    <router-link :to="{ name: 'Landing' }" class="mb-12 mb-12 text-center">
      <img alt="Logo" src="@/assets/media/pyb-logo.png" class="h-90px" />
    </router-link>
    <!--end::Logo-->
    <!--begin::Wrapper-->
    <div class="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
      <!--begin::Form-->
      <form
        class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
        novalidate="novalidate"
        id="kt_sign_in_form"
        @submit.prevent="signin"
      >
        <!--begin::Heading-->
        <div class="text-center mb-10">
          <!--begin::Title-->
          <h1 class="text-dark mb-3">Sign In to Pack Yuh Barrel!</h1>
          <!--end::Title-->
          <!--begin::Link-->
          <div class="text-gray-400 fw-bold fs-4">
            New Here?
            <a
              @click="createAnAccountButton"
              class="link-primary fw-bolder text-pink"
            >
              Create an Account
            </a>
          </div>
          <!--end::Link-->
        </div>
        <!--begin::Heading-->
        <!--begin::Input group-->
        <div class="fv-row mb-10 fv-plugins-icon-container">
          <!--begin::Label-->
          <label class="form-label fs-6 fw-bolder text-dark">Email</label>
          <!--end::Label-->
          <!--begin::Input-->
          <input
            class="form-control form-control-lg form-control-solid"
            type="text"
            v-model.trim="email"
            autocomplete="off"
          />
          <div class="error-text" v-if="!$v.email.required && $v.email.$dirty">
            Email is required
          </div>
          <div class="error-text" v-if="!$v.email.email && $v.email.$dirty">
            Please enter a valid email address
          </div>
          <!--end::Input-->
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
        <!--end::Input group-->
        <!--begin::Input group-->
        <div class="fv-row mb-10 fv-plugins-icon-container">
          <!--begin::Wrapper-->
          <div class="d-flex flex-stack mb-2">
            <!--begin::Label-->
            <label class="form-label fw-bolder text-dark fs-6 mb-0"
              >Password</label
            >
            <!--end::Label-->
            <!--begin::Link-->
            <router-link
              v-if="showForgetPasswordLink"
              :to="{ name: 'ForgotPassword' }"
              class="link-primary fs-6 fw-bolder text-pink"
              >Forgot Password ?</router-link
            >
            <!--end::Link-->
          </div>
          <!--end::Wrapper-->
          <!--begin::Input-->
          <div class="position-relative mb-3">
            <input
              class="form-control form-control-lg form-control-solid"
              :type="passwordFieldType"
              v-model.trim="password"
              autocomplete="off"
            />
            <span
              class="
                btn btn-sm btn-icon
                position-absolute
                translate-middle
                top-50
                end-0
                me-n2
              "
              data-kt-password-meter-control="visibility"
            >
              <i
                :class="eyeIconClass"
                @click="showPassword = !showPassword"
                :title="eyeIconTitle"
              ></i>
            </span>
          </div>

          <div
            class="error-text"
            v-if="!$v.password.required && $v.password.$dirty"
          >
            password is required
          </div>
          <!--end::Input-->
          <div class="fv-plugins-message-container invalid-feedback"></div>
        </div>
        <!--end::Input group-->
        <!--begin::Actions-->
        <div class="text-center">
          <!--begin::Submit button-->
          <button
            type="submit"
            id="kt_sign_in_submit"
            :data-kt-indicator="signingIn"
            :disabled="!formValid"
            class="btn btn-lg btn-primary w-100 mb-5"
          >
            <span class="indicator-label">Continue</span>
            <span class="indicator-progress"
              >Please wait...
              <span
                class="spinner-border spinner-border-sm align-middle ms-2"
              ></span
            ></span>
          </button>
        </div>
        <!--end::Actions-->
        <div></div>
      </form>
      <!--end::Form-->
    </div>
    <!--end::Wrapper-->
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "LoginForm",
  props: {
    signingIn: {
      type: String,
      default: "off",
    },
    showForgetPasswordLink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      result: {},
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    formValid() {
      return !this.$v.$invalid;
    },
    eyeIconTitle() {
      return this.showPassword ? "hide password" : "show password";
    },
    passwordFieldType() {
      return this.showPassword ? "text" : "password";
    },
    eyeIconClass() {
      const defaultClass = "bi fs-2";
      return this.showPassword
        ? `${defaultClass} bi-eye`
        : `${defaultClass} bi-eye-slash`;
    },
  },
  methods: {
    async signin() {
      const login = {
        email: this.email,
        password: this.password,
      };
      this.$emit("login", login);
    },
    createAnAccountButton() {
      this.$emit("createAnAccountButton");
    },
  },
};
</script>

<style scoped></style>
